import Section from "../UI/Section";
import TodoItem from "./TodoItem";
import classes from "./Todos.module.css";

const Todos = (props) => {
  let todoList = <h2>No Todos found. Start adding some!</h2>;

  if (props.items.length > 0) {
    todoList = (
      <ul>
        {props.items.map((todo) => (
          <TodoItem
            key={todo.id}
            done={todo.done}
            createDate={todo.createDate}
            onToggle={() => props.onToggle(todo.id, todo.done)}
            onDelete={() => props.onDelete(todo.id)}
          >
            {todo.text}
          </TodoItem>
        ))}
      </ul>
    );
  }

  let content = todoList;

  if (props.error) {
    content = <button onClick={props.onFetch}>Try again</button>;
  }

  if (props.loading && props.items.length === 0) {
    content = "Loading todos...";
  }

  return (
    <Section>
      <div className={classes.container}>{content}</div>
    </Section>
  );
};

export default Todos;
